var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group"},[_c('select-afip-information'),_c('select-afip-tipo-comprobante'),(_vm.afip_tipo_comprobante_id == 8)?_c('select-incoterms',{on:{"set_selected":_vm.set_incoterms}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }